module.exports = __webpack_public_path__ + "static/media/30.600f805d.ogg";